const en = {
  wheight: 'Peso',
	action: {
		label: 'Acción | Acciones',
    add: 'Agregar',
    added_in_enabled: '+ Actived',
    added_in_disabled: '+ Deleted',
		add_new: 'Añadir nuevo | Añadir nuevo',
		add_new_language: 'Agregar idioma | Agregar idiomas',
		all_profiles: 'Todos los perfiles',
		archive: 'Archivo',
		update_avatar: 'Actualizar avatar',
		category: 'Categoría | Categorias',
		change: 'Cambio',
		comment: 'Comentario',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		compare: 'Comparar',
		compare_reatings: 'Comparar calificación | Comparar opiniones',
		compare_avarage_reatings: 'Compare Avarage Reating | Compare Avarage Reatingsg',
		copy: 'Copia',
		copy_url: 'Copiar URL',
		create_new_process: 'Crear nuevo procesos',
		created: 'Registrado',
		close: 'Cerrar',
		close_process: 'Proceso cerrado',
		delete: 'Eliminar',
    disable: 'Desabilitar',
		end: 'Terminar',
		edit: 'Editar',
		edit_user: 'Editar usuario',
		edit_product: 'Editar producto | Editar productos',
    enable: 'Habilitar',
		generate_link: 'Generar enlace',
		generate_new_link: 'Generar nuevo enlace',
    filter: 'Filtro',
    following: 'Siguiendo',
    inactive: 'Desativa',
    active: 'Ativar',
		include: 'Incluir',
		insert: 'Insertar',
		insert_new: 'Insertar Nuevo',
		move: 'Mover',
		new_profile: 'Nuevo Perfil',
		new_process: 'Nuevo Proceso',
		open: 'Abierto',
		print: 'Imprimir',
		profile_added: 'Perfil agregado | Perfiles agregados',
		register: 'Registrarse',
		register_financial_record: 'Registrar transacción financiera | Registrar transacciones financieras',
		remove: 'Eliminar',
		remember: 'Recuerdame',
		reload: 'Recargar',
		start: 'Empezar',
    show: 'Mostrar',
		show_in_menu: 'Mostrar en el menú principal',
		show_detail: 'Mostrar detalles | Mostrar detalles',
		send: 'Enviar',
		select_file: 'Seleccionar archivo | Seleccionar archivos',
		stock_in: 'Entrada de stock',
		select: 'Seleccione',
		select_image: 'Seleccionar imagen | Seleccionar imagenes',
		search: 'Buscar',
		stock_out: 'Fuera de stock',
		save: 'Guardar',
    saved: 'Registrado | Registrado',
		save_and_select: 'Guardar y seleccionar',
		register_new: 'Registrarse nuevo',
		signup: 'Sign-up',
		signin: 'Sign-in',
		submit: 'Enviar',
    upload: 'Subir',
    unselect: 'Eliminar selección',
		back: 'Volver',
		update: 'Actualizar',
		unarchive: 'Desarchivar',
		use: 'Uso'
	},
	address: {
		label: 'Endereço | Endereços',
		street: 'Rua | Ruas',
		number: 'Número | Números',
		city: 'Cidade | Cidades',
		district: 'Districto | Districtos',
		state: 'Estado | Estados',
		country: 'País | Países',
		complement: 'Complemento | Complementos',
		zip_code: 'Caixa Postal | Caixas Postais'
	},
	average_rating: 'Média da Avaliação | Médias das Avaliações',
	all_my_tasks: 'Todas as minhas tarefas',
	all_my_open_task: 'Todas as minhas tarefas em aberto | Todas as minhas tarefas em aberto',
	archived: 'Arquivado | Arquivados',
	account: 'Conta | Contas',
	all: 'Todos',
	all_processes: 'Todos Processos',
	all_profiles: 'Todos Perfis',
	avatar: 'Avatar | Avatars',
	academic: 'Acadêmco | Acadêmicos',
	access_restriction: 'Restrição de Acesso | Restrições de Acesso',
	avaliation_topic: 'Tópico de Avaliação | Tópicos de Avaliação',
	avaliation_result: 'Resultado de Avaliação | Resultados de Avaliação',
	amount: 'Quantidade | Quantidade',
	best: 'Melhor | Melhores',
	by_profile_owner: 'Mantido pelo usuário dono do perfil | Mantidos pelo dono do perfil',
	barcode: 'Código de Barras | Códigos de Barras',
	best_up: 'Melhor Mais | Melhor Mais',
	best_down: 'Melhor Menos | Melhor Menos',
	basic_data: 'Dados Básico | Dados Básicos',
	billing_email: 'E-mail de Cobrança | E-mails de Cobrança',
	business_name: 'Nome Fantasia | Nome Fantasia',
  boolean: {
    yes: 'Yes',
    no: 'No'
  },
  closed_process: 'Processo Fechado | Processos Fechados',
	closed: 'Fechado | Fechados',
	created_by: 'Criado por',
	created_date: 'Data de criação',
  cv: 'Resume do Perfil | Resumos do Perfil',
  curriculum_vitae: 'Curriculum Vitae | Curriculum Vitae',
	color: 'Cor | Cors',
	customer: {
		label: 'Cliente | Clientes',
		name: 'Nome do Cliente| Nomes dos Clientes',
		main_name: 'Nome principal do cliente',
		code: 'Código do Cliente | Códigos dos Clientes',
		contact: 'Contacto do Cliente | Contactos dos Clientes'
	},
	curriculum: 'Curriculum | curriculums',
	compare_profile: {
		label: 'Compare Profiles',
		desc: 'Define the evaluation criteria of the profiles and compare the results.'
	},
	competency_dossier: 'Dossiê de Competências | Dossiês de Competências',
	current_period: 'Período Corrente',
	core: 'Core | Cores',
	core_skill: 'Habilitação Principal | Habilitações Principais',
	core_skill_not: 'Não é Habilitação Principal | Não é Habilitações Principais',
	code: 'Código | Códigos',
	cost: 'Custo | Custos',
	context: 'Contexto | Contextos',
	country: 'País | Países',
	company: 'Empresa | Empresas',
	company_name: 'Nome da Empresa | Nome das Empresas ',
	certification: 'Certificado | Certificados',
	city: 'Cidade | Cidades',
	current: 'Atual | Atuais',
	custom_label: 'Personalizado | Personalizados',
	confirmed: 'Confirmado | Confirmado',
	canceled: 'Cancelado',
	currency: {
		label: 'Moeda | Moedas',
		euro: 'Euro | Euros',
		dolar: 'Dolar| Dolars',
		pound: 'Pound | Pounds',
		real: 'Real | Reais'
	},
  content: 'Conteúdo | Conteúdos',
  no_content: 'No content | No contents',
	closing_date: 'Data de Fechamento| Datas de Fechamento',
	closed_data: 'Data de Fechamento| Datas de Fechamento',
	closed_with_delay: 'Fechado com Atraso',
	closed_with_delay_explanation: 'Processo fechado após o prazo',
	closed_in_time: 'Fechado em Tempo',
	closed_in_time_explanation: 'Processo fechado antes do prazo',
	contact: {
		label: 'Contacto | Contactos',
		send_your_msn: 'Mande sua mensagem',
		any_questions: `Alguma questão ou dúvida?
						Mande agora uma mensagem.`,
		suporte_contact: 'Contacto de suporte',
		if_prefer_send_email: `Se preferir, envie um e-mail para nosso suporte`
	},
  done: 'Finalizado | Finalizados',
  delete_account: {
    label: 'Excluir Conta e Perfil',
    text: `Para excluir sua conta e perfil, envie um mensagem
            para <b>{email}</b> com sua solicitação.`
  },
	disabled: 'Desablitado | Desablitado',
	description: 'Description | Descriptions',
	deleted: 'Excluído | Excluído',
	default: 'Padrão | Padrões',
	default_label: 'Rótulo Padrão| Rótulos Padrão',
	derived_process: 'Processo Derivado | Processos Derivados',
	discount: 'Desconto | Descontos',
	down: 'Baixo',
	developed_projects: 'Projeto Desenvolvido | Projetos Desenvolvidos',
	dashboard: 'Dashboard',
	deadline: 'Prazo | Prazos',
	data: 'Data | Datas',
	date: {
		start_day: 'Dia Inicial',
		end_day: 'Dia Final',
		label: 'Data | Datas',
		due_date: 'Vencimento | Vencimento',
		paid_date: 'Data Pagamento | Data Pagamentos',
		by: 'Data por | Data por',
		date_range: 'Período | Períodos',
		year: 'Ano | Anos',
		birth: 'Aniversário | Aniversários',
		birth_day: 'Data de Nascimento | Datas de Nascimento',
		birthday: 'Data de Nascimento | Datas de Nascimento',
		today: 'Hoje',
		last_week: '1 Semana | {n} Semanas',
		last_month: '1 Mês | {n} Meses',
		last_year: '1 Ano | {n} Anos',
		one_week: '1 Week',
		one_month: '1 Month',
		one_year: '1 Year',
		month: {
			label: 'Mês | Meses',
			by_number: {
				short: {
					1: 'Jan',
					2: 'Fev',
					3: 'Mar',
					4: 'Abr',
					5: 'Maio',
					6: 'Jun',
					7: 'Jul',
					8: 'Ago',
					9: 'Set',
					10: 'Out',
					11: 'Nov',
					12: 'Dez',
				}
			}
		}
	},
	document_model: 'Modelo de Documento | Modelos de Documentos',
	specific_period: 'Específico Período | Específico Períodos',
  enabled: 'Habilitado | Habilitados',
  extract: 'Extrato | Estratos',
	exception: 'Exception | Exceptions',
	experience: 'Experience | Experiences',
	external_link: {
		label: 'Link Externo | Links Externo',
		message: {
			confirm_delete_link: 'O link será excluído permanentemente. Confirmar?',
			explain_in_process: `Los enlaces externos permiten que otras personas se registren
                sus perfiles directamente ingresando sus datos. <br>
                Los usuarios asociados con un enlace serán notificados cada vez
                que un nuevo perfil es
                registrado por el enlace. <br>
                Comparte el enlace en las redes sociales, en tu
				sitio web corporativo, por correo electrónico o donde quieras. <br> <br>
				<strong>
				<a href="/#/admin/profile_types">
				<u>
				Definir y mantener actualizadas las políticas de privacidad y seguridad.
				condiciones de uso, acceda a la configuración de tipo de perfil
				correspondiente. <a href="/admin/profile_types/"> Acceda aquí <a/>
				</u>
				<a> </strong>`,
			explain_in_profile: `Los enlaces externos permiten que otras personas se registren
                sus perfiles directamente ingresando sus datos. <br>
                Los usuarios asociados con un enlace serán notificados cada vez
                que un nuevo perfil es
                registrado por el enlace.<br>
								Comparte el enlace en las redes sociales, en tu
                sitio web corporativo, por correo electrónico o donde quieras. <br>
                Comparte este enlace en las redes sociales, en tu empresa
				sitio web o simplemente enviarlo por correo electrónico.<br><br>
                <strong>Para definir y mantener actualizadas las políticas de
                privacidad y los términos de uso, acceda a la configuración de
                tipo de perfil correspondiente..</strong>`,
      change_terms_in_profile_settings: `Para definir y actualizar los Términos y Políticas de uso
				que deben ser aceptados por los propietarios del perfil, accedan al
				configuración específica del tipo de perfil.
                 Como el registro no está siendo actualizado por
				propietario del perfil mismo, se indica que mantenga evidencia de que el mismo
				de acuerdo con los términos expresados. Cuando indicas en el registro de un perfil de otro
				La persona que acepta los términos en realidad afirma que el propietario del perfil está de acuerdo. <br> <br>
				Verifique y respete la legislación vigente en su país en materia de protección de datos.
				Si no está seguro acerca de esta legislación, busque el asesoramiento legal adecuado antes de registrarse
				Perfiles de terceros.
                `
		}
	},
	experience_years: 'Sem Experiência | {years} ano | {years} anos',
	email: 'E-mail | E-mails',
	education: 'Educação | Educação',
	expense: 'Despesa | Despesa',
	end: 'Fim | Finais',
	end_date: 'Data de Fim | Datas de Fim',
	error: {
    label: 'Erro',
    file_too_big: 'Maximum allowed size of 1mb',
		sending_data: 'Erro ao enviar os dados',
		generic: 'Ocorreu um erro. Cod. {code}',
		item_is_required: '{item}: É necessário.',
    comment_something: 'Comment Algo',
    user_not_confirmed_email_sent: `Correo electrónico no confirmado Un
      mensaje de confirmación fue enviado nuevamente. Por favor, acceda al enlace en el mensaje.`
	},
	profile_rules: {
		allow_use_profile_any_process: 'Allow use profile any process',
		expire_profile: 'Perfil Expirado',
		not_expire: 'Não Expirado',
		only_on_process: 'Apenas um processo',
		after_end_processes: 'Depois de finalizar processos',
		after_n_months: 'Após 1 mês | Após {n} meses',
		allow_internal_share: 'Permitir compartilhamento interno',
		only_internal_information:
		{
			label: 'For internal use only',
			explanation: 'Visible only to administrative users of the account.'
		},
		allow_external_share: 'Permitir compartilhamento externo',
		is_privacy_policy: 'É política de privacidade',
		contact: {
			registred_process: 'Permite contacto para processos vinculados.',
			other_process: 'Permite contacto para todos os processos.'
		},
		accept_by_other_user: `Aceitação dos termos e políticas
			e de suas condições quando o registro não é realizado pelo
			proprietário do perfil profile deve ser comprovado pela prova
			da aceitação que é de responsabilidade do usuário que realizou o cadastro
			<br>
					Dica: Anexe arquivos comprovativos da aceitação do cadastro.<br>`
	},
	from: 'De',
	file_attachment: 'Anexar Arquivo',
	feature: 'Recurso | Recursos',
	fixed_cost: 'Custo Fixo | Custos Fixos',
	first_name: 'Primeiro Nome | Primeiros Nomes',
	flow: 'Fluxo | Fluxos',
	flow_process: 'Fluxo de Processo | Fluxos de Processos',
	file: 'Arquivo | Arquivos',
	field: 'Campo | Campos',
	filter: 'Filtro | Filtros',
	filter_by_user: 'Filtrar por usuário | Filtrar por usuários',
	financial: {
		balance: 'Balance | Balance',
		paid: 'Pago | Pago',
		opened: 'Em Aberto | Em Aberto',
		received: 'Recebido | Recebidos',
		financial_process: 'Processo Financeiro | Processos Financeiros',
		income_registration: 'Registro de Receita | Registros de Receitas',
		income: 'Receita | Receitas',
		expense_registration: 'Registro de Despesa| Registro de Despesas',
		expense: 'Despesa| Despesas',
		account_receivable: 'Account Receivable| Account Receivable',
		financial_recovery: 'Cobrança | Cobranças',
		account: 'Contas | Contas',
		all_account: 'Todas Contas',
		receipt_method: 'Método Recebimento | Métodos Recebimentos',
		receipt: 'Recebimento | Recebimento',
		payment: 'Pagamento | Pagamento',
		cost_center: 'Centro de Custo | Centros de Custo',
		default_cost_center: 'Centro de Custo Padrão| Centros de Custo Padrão',
		bank_account: 'Contas Bancárias | Contas Bancárias',
		financial_account: 'Conta Bancária | Contas Bancárias',
		default_account: 'Conta Bancária Padrão | Contas Bancárias Padrão',
		label: 'Financeiro',
		financial_record: 'Registro Financeiro | Registros Financeiros',
		installment: 'Parcela | Parcelas',
		payment_method: 'Método Pagamento | Métodos Pagamentos',
		price: 'Preço | Preços',
		rate: 'Taxa | Taxas',
		discount: 'Desconto | Descontoss',
		interest: 'Juros | Juros',
		additional_fee: 'Taxa Adcional | Taxas Adicionais',
		percentage_discount: 'Desconto Percentual',
		fixed_discount: 'Desconto Fixo',
		allow_installment: 'Permitir Parcelamento',
		receive_single_installment: 'Receber em parcela única',
		type_interest: 'Tipo de Juros',
		compound_interest: 'Juros Compostos',
		simple_interest: 'Juros Simples',
		add_to_total: 'Adicionar ao Total',
		totals_by_cost_center: 'Totais por Centro de Custo',
		grouped_by_cost_center: 'Agrupado por Centro de Custo',
		incomes_by_cost_center: 'Receitas Agrupado por Centro de Custo',
		expenses_by_cost_center: 'Despesas Agrupado por Centro de Custo',
		message: {
			cant_edit_paid_records: `Registos de pagamento podem apenas ser excluídos. Ao excluir esses registro, todos os seus registros financeiros serão excluídos também.`,
			cant_edit_received_records: `Registos de recebimento podem apenas ser excluídos. Ao excluir esses registro, todos os seus registros financeiros serão excluídos também. `,
			general_discount_all_payments: 'Taxas de desconto para todos os pagamentos',
			specific_discount_by_installments: 'Desconto específico por quantidade de parcelas'
		}
	},
	gender: 'Gênero | Gêneros',
	general_registration: 'Registro Geral | Registros Gerais',
	home: 'Home | Homes',
	height: 'Altura | Alturas',
	help_center: 'Central de Ajuda | Centrais de Ajuda',
  input: 'Campo | Campos',
  in_progress: 'Em Andamento',
	id: 'Id | Ids',
	import_product: 'Import Product | Import Products',
	import_selected_profiles: 'Import Selected Profiles | Import Selected Profile',
	incomplete: 'Incompleto | Incompletos',
	institution: 'Instituição | Instituições',
	instalment: 'Parcela | Parcelas',
	item: 'Item | Itens',
	interview: 'Intrevista | Intrevistas',
	income: 'Receita | Receitas',
	logout: 'Log Out',
	logo: 'Logo | Logos',
	link: 'Link | Links',
	link_to_register_form: 'Link para o formulário de cadastro | Links para os formulários de cadastro',
	link_to_register: 'Link para registrar perfil| Links para registrar perfis',
	linked_user: 'Usuário| Usuários',
	linked_user_status: 'Usuários associados e status | Usuário associado e status',
	last_update: 'Última Atualização | Últimas Atualizações',
	linked_process: 'Processo Associado | Processos Associados',
	lebel: 'Rótulo | Rótulos',
  level: 'Nível | Níveis',
	lag_level: {
    ALL: {
      label: 'All levels',
      desc: ''
    },
    1: {
      label: 'Nativo',
      desc: 'Língua materna'
    }
    ,
    2: {
      label: 'Fluente',
      desc: 'Alto nível de proficiência'
    },
    3: {
      label: 'Médio',
      desc: 'Comunicação básica'
    },
    4: {
      label: 'Baixo',
      desc: 'Entende e se comunica com dificuldade'
    }
  },
	education_level: {
    1: {
      label: 'Secundário'
    }
    ,
    2: {
      label: 'Superior'
    },
    3: {
      label: 'Mestrado'
    },
    4: {
      label: 'Doutoramento'
    }
  },
	list: 'Lista | Listas',
	login: {
		label: 'Iniciar sesión',
		forgot_password: '¿Olvidaste tu contraseña?',
		change_password: 'Cambiar contraseña',
		request_change_password: 'Solicitar nueva contraseña',
		login_error: 'Lo sentimos, datos de acceso incorrectos ...',
		change_pw_error: 'Error al actualizar la contraseña.',
		request_pw_msn: 'Solicitud recibida con éxito. <br> Se envió un correo electrónico a {email} con un enlace para actualizar la contraseña.',
    password_updated: 'Contraseña actualizada.',
    repeat_password: 'Repite la contraseña'
	},
	language_set: {
		label: 'Linguagem | Linguagens',
		portuguese: 'Português',
		portuguese_br: 'Português BR',
		english: 'Inglês',
		english_us: 'Inglês - US',
		spanish: 'Espanhol'
	},
	link_generate: {
		short_explanation: {
			what_is: 'O usuário pode criar um usuário e registrar seu perfil.',
			process_bind: 'Os processos serão associados com as contas do perfil',
			user_bind: 'Os usuários serão associados com as contas do perfil. Quando um perfil é atualizado ou um usuário envia um mensagem o dono do perfil receberá mensagens de aviso.',
		}
	},
	language: {
		label: 'Languagem | Languagens',
		portuguese: 'Português',
		portuguese_br: 'Português BR',
		english: 'Inglês',
		english_us: 'Inglês - US',
		spanish: 'Espanhol'
	},
	main: 'Principal | Principais',
	model: 'Modelo | Modelos',
	menu: 'Menu | Menus',
	min: 'Min | Min',
	max: 'Max | Max',
	main_user: 'Usuário Principal | Usuários Principais',
	main_process: 'Processo Principal | Processos Principais',
	main_profiles: 'Perfil Principal | Perfis Principais',
	media: 'Mídia | Mídias',
	my_account: 'Minha conta | Minhas contas',
	min_stock: 'Max Estoque | Max Estoques',
	max_stock: 'Min Estoque | Min Estoques',
	my_user: 'Meu Usuário | Meus Usuários',
	my_profile: 'Meu Perfil | Meus Perfis',
	method: 'Metodo | Metodos',
	module: 'Módulo | Módulos',
	municipal_code: 'Código Municipal | Códigos Municipais',
	message: {
    new_skill_in_select: 'To create a new skill, just type and select it.',
    visible_to_profile_owner: 'Visible en el área del propietario del perfil. Datos básicos del proceso solamente.',
    agree_update_terms: 'Entiendo y asumo la responsabilidad de los términos de uso y las políticas de privacidad aplicadas al registro del perfil.',
    agree_above_terms: 'Entiendo y estoy de acuerdo con las pautas anteriores.',
    we_are_preparing_your_account: 'Estamos preparando su cuenta...',
    account_confirmed: 'Gracias, cuenta confirmada!',
    compare_reatings_click: 'Elige los perfiles que deseas comparar.',
		open_windows: 'Abrir Janela',
		page_not_found: 'The page you requested could not be found.',
		there_id_no_selected_profile: 'There is no selected profile',
		when_you_receive_payment: 'Quando recebes o pagamento',
		when_you_make_payment: 'Quando fazes o pagamento',
		need_change_plan: 'Necesita cambiar el plan. <ins>Cambiar plan</ins>',
		confirm_change_account_plan: 'Quando o plano é alterado, o valor do plano será ajustado e será enviado um e-mail em 48 horas com as informações da alteração da cobrança, se fora do período gratuito.',
		change_account_plan_confirmed: 'Mudança de plano CONFIRMADA',
		change_account_plan_canceled: 'Mudança de plano CANCELADA',
		choose_process_in_dashboard: 'Sem dados ou sem tipo de processo selecionado para o Dashboard.<br> Escolha os processos que desejas ver aqui.',
		average_from_x_records: 'Média de 1 registro | Média de {n} registros',
		total_x_ratings_submitted: '1 de avaliação submetida | {n} de avaliações submetidas',
		chart_one_year_by_process_type: 'Período de 12 meses (considera processos arquivados)',
		started_x_closed_process: 'Iniciados X Fechados',
		active_processes_by_status: 'Processos activos por status (não arquivados)',
		actived_processes: 'Processo Ativo | Processos Ativos',
		actived: 'Ativo | Ativos',
		label: 'Menssagem | Mensagens',
		delete_completed: 'Exclusão completada',
		remove_completed: 'Remoção completada',
		delete_canceled: 'Exclusão cancelada',
		remove_canceled: 'Remoção cancelada',
		archive_completed: 'Archive completada',
		archive_canceled: 'Archive cancelada',
		unarchive_completed: 'Arquivamento completado',
		unarchive_canceled: 'Arquivamento cancelado',
		equal_or_greater: 'Igual ou maior',
    terms_and_policies: 'Termos e Políticas',
		privacy_policies: 'Políticas de Privacidad',
		terms_of_use: 'Terminos de Uso',
		account_registered: 'Conta registrada',
		confimation_sent: `<p class="h4">
      Mensaje con un enlace de confirmación
      fue enviado a {email}.
      </p>
      <p class="h4">
      Por favor revise el correo electrónico.
      </p>`,
    confimation_sent_simple: `Una mensaje con un enlace
      de confirmación fue enviado a {email}.`,
		mensage_deleted: 'Mensage Deleted.',
		mensage_sent: 'Mensagem enviada.',
		mensage_sent_thanks: 'Mensagem enviada. Obrigado!',
		no_rating_registred: 'Sem registro de avaliação',
		will_response_soon: `Nós responseremos em breve.`,
		are_you_sure: 'Tem certeza?',
		confirm_delete: 'Confirmar exclusão?',
		confirm_archive: 'Confirmar Arquivamento?',
		confirm_unarchive: 'Confirmar Desarquivamento?',
		from_your_selected_skills: 'das Habilidade selecionadas',
		filter_by_language: 'Filtrar por linguagem | Filtrar por linguagens',
		filter_by_skill: 'Filtrar por Habilidade | Filtrar por Habilidades',
		slogan: 'Process and Profile Management',
		show_edit_mode: 'Mostrar Modo de Edição',
    hide_edit_mode: 'Esconder Modo de Edição',
    hide_sensitive_data: 'Ocultar datos confidenciales',
		repeat_password: 'Repetir palavra-passe',
		hello: 'Olá!',
		coded_by: 'Desenvolvido por',
		updated_by: 'Atualizado por',
		updated: 'Atualizado | Atualizados',
		created_by: 'Criado por',
		month_free: '{n} Dia libre | {n}º Días libres',
		no_records: 'Sem registros',
		no_profile_added: 'Sem prefirs adcionados',
		name_or_code: 'Nome ou Código',
		number_job_openings: 'Quantidade de vagad abertas',
		number_profile_to_select: 'Quantidade {label} para selecionar',
		profile_to_select: '{label} para selecionar',
		data_visible_to_candidate: 'Informação visível para o usuário do dono do perfil.',
    avaliation_topic_x_weight: 'Tópicos de Avaliação X Peso',
    send_owner_link: 'Enviar al propietario del perfil',
		send_owner_link_txt: `O dono do perfil poderá atualizar seus dados, acompanhar
		informações basic dos seus processos, anexar arquivos e enviar mensagens.`,
		select_profile_with_ratings: 'Selecione um perfil com avaliação.',
		resquest_owner_update: 'Solicite atualização pelo dono do perfil',
		copy_tags: `Copie (Ctrl + C) e cole (Ctrl + V) como uma TAGs no editor
					de texto para exibir o conteúdo correspondente quando
					gerar o documento.`,
		owner_restriction: `Apenas o autor e usuários com o quais houve
							compartilhamento.<br>
							A menos que haja limitação do perfil do usuário:`,
		allow_as_phisical_person: 'Permitir como uma pessoa física.',
		allow_as_company: 'Permitir como empresa.',
    from_selected_skills: 'das Habilidade selecionadas {label}',
		confirm_leave_form: '¿Confirmar para dejar este formulario? Ahorre primero para no perder sus cambios.',
		confirm_remove_profile_in_process: 'Confirme remover perfil desse processo | Confirme remover perfis desse processo',
	},
	name: 'Nome | Nomes',
  not_archived: 'Não Arquivado | Não Arquivados',
  not_confirmed: 'No confirmado | No confirmado',
	not_rated: 'No Calificados | No Calificados',
	not_selected: 'Não Selecionado | Não Selecionados',
	name_singular: 'Nome Singular| Nomes Singular',
	name_plural: 'Nome Plural| Nomes Plural',
	new_product: 'New Product | New Products',
  new: 'Novo | Novos',
  new_type: 'Nuevo tipo| Nuevos tipos ',
	number: 'Número | Números',
	next: 'Próximo | Próximos',
	new_reating: 'Nova Avaliação | Novas Avaliações',
	no_status_registred: 'Sem Status Registrado | Sem Status Registrados',
	new_account: {
		create_new_account: 'Registre nova conta',
		create_your_account: 'Registre sua conta',
		profile_management: 'Gestão de Perfis',
		process_management: 'Gestão de Processos',
		financial_management: 'Financial Management',
		text: {
			profile_features: `- Registre perfis;<br>
								- Área do dono do perfil;<br>
								- Processos de recrutamento;<br>
								- Enviar mensagens rápidas para os donos dos perfis;<br>
								`,
			process_features: `- Tarefas; <br> 
								- Processos de recrutamento;<br>
								- Processo de contratação;<br>
								- Entrevista;<br>
								- Vendas;<br>
								- Cotação;<br>
								- Compra;<br>
								- Projetos;<br>
								- Processo personalizados;<br>
								- Outros...<br>
								`,
			financial_features: `- Register Incomes:<br>
								- Register Expenses;<br>
								- Financial Reports;<br>`
		}
	},
	only_open_task: 'Apenas tarefas em aberto | Apenas tarefas em aberto',
	official_identification: 'Identificação Oficial | Identificações Oficiais',
	observation: 'Observação | Observações',
	ok: 'Ok',
	operating_area: {
    label: 'Área de Atuação',
    culture: 'Cultura',
		human_resouces: 'Recursos Humanos',
		provide_services: 'Provedor de Serviços',
		product_sales: 'Venda de Produtos',
		products_and_services: 'Produtos e Serviços',
		financial: 'Financeiro',
		education: 'Educação',
		ti: 'TI',
    marketing: 'Marketing',
    health: 'Saúde',
		others: 'Outros',
	},
	opened: 'Em Aaberto | Em Aberto',
	open_task: 'Tarefa em Aberto | Tarefas em Aberto',
	overview: 'Overview | Overviews',
	origin_process: 'Processo de Origem | Processos de Origem',
	per_user_per_month: 'por usuário por mês',
	pending: 'Pendente',
	process: 'Processo | Processos',
	process_settings: 'Configuração do Processo | Configurações dos Processos',
	process_permissions: 'Permissição do Processo | Permissões do Processo',
	perishable: 'Perecível | Perecíveis',
	process_module: {
		label: 'Módulo do Processo| Módulos do Processo',
		process: 'Processo | Processos',
		messagem: {}
	},
	process_id: 'ID Processo | IDs Processos',
	process_type: 'Tipo de Processo | Tipos de Processos',
	process_resume: 'Resumo do Processo | Resumo dos Processos',
	profile: 'Perfil | Perfis',
	profile_status: {
		label: 'Profile Status | Profiles Status',
		desc: 'Easily track and update the status of all profiles that participate in a process.',
	},
	profile_group: 'Grupo de Perfil | Groups de Perfil',
	profile_removed: 'Perfil Removido | Perfis Removidos',
	profile_settings: 'Configuração do Perfil | Configurações dos Perfis',
	profile_permissions: 'Permissão do Perfil | Permissões do Perfil',
	profile_n: '{n} Perfil | {n} Perfis',
	profile_type: 'Tipo de Perfil | Tipos de Perfis',
	profile_user: 'Usuários do Perfil | Usuários dos Perfis',
	permissions: {
		label: 'Permissão | Permissões',
		allow_rating_profile: 'Permitir avaliar perfil | Permitir avaliar perfis',
		profile_user_permission: 'Permissão de usuário de perfil | Permissões de usuários de perfil',
		show_in_his_process_list: 'Exibir em sua listagem de processo | Exibir em sua listagens de processos',
		show_basic_data: 'Exibir dado básico | Exibir dados básicos',
		show_product: 'Exibir Produto | Exibir Produtos',
		show_product_value: 'Exibir valor do produto | Exibir valor dos produtos',
		show_income: 'Exibir Conta a Receber | Exibir Contas a Receber',
		show_expense: 'Exibir Conta a Pagar | Exibir Contas a Pagar',
		show_file: 'Exibir Arquivo | Exibir Arquivos',
		show_process_flow: 'Exibir flúxo do processo | Exibir flúxo dos processos',
		show_profile_list: 'Exibir Lista de Perfis | Exibir Listas de Perfis',
		show_profile_cv: 'Exibir CV | Exibir CVs',
		show_comment: 'Exibir Comentário | Exibir Comentários',
		add_file: 'Adicionar Arquivo | Adicionar Arquivos',
		in_selective_process: 'No processo selectivo | Nos processos seleticos'
	},
	product: 'Produto | Produtos',
	product_destination: 'Destinatário do Produto | Destinatários do Produtos',
	product_origin: 'Origem do Produto | Origens dos Produto',
	product_updated: 'Produto Atualizado | Produtos Atualizados',
	product_registred: 'Produto Registrado| Produtos Produtos',
	project: 'Projeto | Projetos',
	position: 'Posição | Posições',
	previous: 'Anterior | Anteriores',
	password: 'Palavra-Passe | Palavras-Passe',
	password_repeat: 'Repetir Palavra-Passe | Repetir Palavras-Passe',
	payment: 'Pagamento | Pagamentos',
	point: 'Ponto | Pontos',
	profile_id: 'ID do Perfil | IDs dos Perfis',
	professional_identification: 'Identificação Profissional | Identificações Profissionais',
	plan: {
		label: 'Plano | Planos',
		for_custom: 'Para planos personalizados, contactar {email}',
		use_your_domain: {
			label: 'Seu Dominio',
			text: 'Será usado o seu domínio para acessar a sua conta.'
		},
		use_your_email: {
			label: 'Seu e-mail',
			text: 'Poderá usar o e-mail corporativo quando o sistema enviar mensagens da sua conta.'
		},
		your_logo: {
			label: 'Your Logo',
			text: 'Use your corporate email address when the system sends messages from your account.'
		},
		custom_theme: {
			label: 'Tus colores y temas',
			text: 'Use your corporate email address when the system sends messages from your account.'
		},
		custom_features: {
			label: 'Recursos Personalizados',
			text: 'Use your corporate email address when the system sends messages from your account.'
		}
  },
	ranking: 'Ranking | Rankings',
  resend_confimation_email: 'Reenviar correo electrónico de confirmación.',
	result: 'Resultado | Resultados',
	registred_reating: 'Avaliação Registrada | Avaliações Registradas',
	reatings: 'Avaliação | Avaliações',
	registred_date: 'Data de Registro | Datas de Registro',
	ratting_submitted: 'Avaliação Submetida | Avaliações Submetidas',
	ratting_deleted: 'Avaliação Deletada | Avaliações Deletadas',
	required: 'Obrigatório | Obrigatórios',
	recent_activity: 'Atividade Recente | Atividades Recentes',
	responsible: 'Responsável | Responsáveis',
	responsible_user: 'Usário responsável | Usários responsáveis',
	raking_position: 'Posição no Raking | Posições no Raking',
	rating_record: 'Registro de Avaliação | Registros de Avaliações',
	requirement: 'Requisito | Requisitos',
	role: 'Papel | Papeis',
  seved: 'Salvo | Salvo',
	referral: {
		label: 'Referral | Referras',
		have: 'Has Referral | Has Referras',
    label_email: 'Referral Email| Referrals Emails',
    text_register: 'E-mail of the person who introduced you to the system'
  },
	resume: 'Resumo | Resumos',
	record: 'Registro | Registros',
	rating: 'Avaliação | Avaliações',
	subject: 'Assunto | Assunto',
	setting: 'Configuração | Configurações',
	stock_control: 'Controle de Estoque | Contole de Estoques',
	state_code: 'Código do Estado | Códigos do Estado',
	selected: 'Selecionado | Selecionados',
	start: 'Começo | Começos',
	started: 'Iniciado | Iniciados',
	start_date: 'Data Início | Datas Início',
	shipping: 'Entrega | Entregas',
	specialization: 'Especialização | Especializações',
  summary: 'Apresentação | Apresentações',
  start_page: "Página de inicio",
	serial_number: 'Serial Number | Serial Numbers',
	selective_process: 'Processo Selectivo | Processo Selectivo',
  skill: 'Habilidade | Habilidades',
  skill_levels: {
    ALL: 'Todos | Todos',
    1: 'Beginner | Beginners',
    2: 'Intermediate | Intermediates',
    3: 'Professional | Professionals',
    4: 'Senior | Seniors',
    5: 'Expert | Experts'
  },
	stock: 'Estoque | Estoques',
	service: 'Serviço | Serviços',
	selection_data: 'Dado Selecionado | Dados Selecionados',
	status: 'Status | Status',
	status_detail: 'Detalhe do Status| Detalhe do Status',
	supplier: {
		label: 'Fornecedor | Fornecedores',
		name: 'Nome Fornecedor | Nomes Fornecedores',
		code: 'Código Fornecedor | Códigos Fornecedores',
		contact: 'Contacto Fornecedor | Contactos Fornecedores'
	},
	to: 'Para',
	to_sale: 'Para Venda | Para Vendas',
	tag: 'Tag | Tag',
	title: 'Título | Títulos',
	street: 'Rua | Ruas',
	weight: 'Peso | Pesos',
	task: 'Tarefa | Tarefas',
	team_management: 'Team Management',
  term: 'Termo | Termos',
	type: 'Tipo | Tipos',
	time: 'Hora | Horas',
	technology: 'Tecnologia | Tecnologias',
	total: 'Total | Totais',
	total_by_status: 'Total por Status | Totais por Status',
	topic_point: 'Pontuação no Tópico | Pontuações nos Tópicos',
  topic: 'Tópico| Tópicos',
  topic_type: {
    integer: 'Number',
    value: 'Money',
    decimal: 'Number Decimal',
    stars: 'Stars',
    boolean: 'Yes/No'
  },
	undone: 'Não Finalizado | Não Finalizados',
  url: 'Url | Urls',
  unlimited: 'Ilimitado | Ilimitados',
	updated: 'Atualizado | Atualizados',
	user: {
		label: 'Usuário | Usuários',
		select: 'Selcione usuário | Selcione usuários'
	},
	n_user: {
		label: '{n} Usuário | {n} Usuários'
	},
	value: 'Valor | Valores',
	your_profile: 'Seu Perfil | Seu Perfil',
	your_comment: 'Seu Comentário | Seu Comentários',
	your_message: 'Sua Mensagem | Suas Mensagens',
	warning: 'Aaviso | Avisos',
	kanban: 'Card | Cards',
	site: {
		register: {
			btn_create_your_account: 'Criar Conta FREE',
			registred: {
				title: 'Account registered',
				msn: 'A message with a confirmation link has been sent to {email} from app@processflex.com.',
				check_email: 'Please check your email.',
				accept_terms: 'I accept the terms of use',
				accept_privacy_policy: 'I accept the privacy policy'
			}
		},
		home: {
			title: 'Software para Gestión de Procesos y Perfiles',
			subtitle: 'Administre sus procesos y su base de datos de perfil.',
			features: {
				registred_process: {
					title: 'Processos pre-registrados',
					subtitle: 'Procesos prerregistrados y personalizables (Selección, Cotización, Compra, Venta y más.'
				},
				create_process: {
					title: 'Crie novos tipos de processos',
					subtitle: 'Criação livre de novos tipos de processos.'
				},
				selective_process: {
					title: 'Recrutamento / Processo selectivo',
					subtitle: 'Adicione Perfis, defina critérios de avaliação e tenha o comparativo entre os perfis.'
				},
				profile_bank: {
					title: 'Cadastre perfis',
					subtitle: 'Crie o seu banco de perfis com contato, endereço, áreas de conhecimento e tecnologias, mensagens, projectos e muito mais.'
				},
				profile_area: {
					title: 'Área do dono do perfil',
					subtitle: 'Tenha disponível uma área para cadastro direto pelo próprio dono do perfil. Relacioneo automaticamente o perfil com processos criados, com usários do sistema, envie mensagens e muito mais.'
				},
				financial: {
					title: 'Controle financeiro dos processos',
					subtitle: 'Registre contas a pagar, contas a receber dentro dos processos ou de forma independente.'
				}
			}
		},
		features: {
			title: 'Recursos',
			subtitle: 'Recursos flexíveis e personalizáveis, como realmente precisas.',
			processes: {
				title: 'Processos',
				subtitle: 'Crie e personalize processos',
				pre_registred: {
					title: 'Pré-registrados:',
					list: `
					<ul>
						<li>Recrutamento / Processo Selectivo</li>
						<li>Cotação</li>
						<li>Compra</li>
						<li>Venda</li>
						<li>Reunião</li>
						<li>Eventos</li>
						<li>Projetos</li>
						<li>Outros...</li>
					</ul>`
				},
				features: {
					title: 'Recursos',
					list: `
					<ul>
						<li>Crie novos tipos de processos</li>
						<li>Personalizar os status</li>
						<li>Adicione perfis</li>
						<li>Avalie e compare perfis</li>
						<li>Personalizar os campos</li>
						<li>Vincule com usuários</li>
						<li>Mande mensagens</li>
						<li>Anexe arquivos</li>
						<li>Adicione productos</li>
						<li>Registros financeiros</li>
						<li>Personalizar e gerenciar pelo KanbanCustomize and manage status through Kanban</li>
						<li>E muito mais...</li>
					</ul>`
				},
			},
			profiles: {
				title: 'Per',
				subtitle: 'Customizable your profile bank',
				pre_registred: {
					title: 'Pré-registrados:',
					list: `
					<ul>
						<li>Clientes</li>
						<li>Fornecedores</li>
						<li>Candidatos</li>
						<li>Consultores</li>
						<li>Empregados</li>
						<li>Vendedores</li>
						<li>Transportadores</li>
						<li>Outros...</li>
					</ul>`
				},
				features: {
					title: 'Recursos',
					list: `
					<ul>
						<li>Crie novos tipos de perfil</li>
						<li>Personalizar campos</li>
						<li>Habilidades dos perfis</li>
						<li>Projectos dos perfis</li>
						<li>Vincule com usuários</li>
						<li>Área do dono do perfil</li>
						<li>Mande mensagens</li>
						<li>Anexar arquivos</li>
						<li>Outros...</li>
					</ul>`
				},
			},
			financial: {
				title: 'Financial',
				subtitle: 'Controle financeiro dos processos',
				features: {
					title: 'Recursos',
					list: `
					<ul>
						<li>Contas a Pagar</li>
						<li>Contas a Receber</li>
						<li>Centro de Custo</li>
						<li>Configurações de métodos de pagamentos</li>
						<li>Registros financeiros dos processos</li>
						<li>Extrato financeiros</li>
					</ul>`
				},
			}
		}
	}
}

export default en;

